import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { CheckCheck, XCircle } from "lucide-react";
import { approveBill, rejectBill } from "../../api/accounting";
import { NeuButton } from "../../components/neu/Neu";
import { useApiError } from "../../hooks/useApiError";

// نافذة اعتماد المدير — قرار موافقة/رفض فقط. المحاسب يختار الصندوق والمستلم لاحقاً.
export const BillApproveDialog = ({ bill, onDone, onCancel }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const approve = async () => {
    setBusy(true);
    try { await approveBill(bill.id, note.trim() || null);
      toast.success(t("acct.bills.approve.done")); onDone();
    } catch (e) { toast.error(describe(e)); } finally { setBusy(false); }
  };
  const doReject = async () => {
    const reason = window.prompt(t("acct.bills.approve.reason"), "");
    if (reason === null) return;
    setBusy(true);
    try { await rejectBill(bill.id, reason || ""); toast(t("acct.bills.approve.rejected")); onDone(); }
    catch (e) { toast.error(describe(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-content-center bg-black/60 p-4" onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()} data-testid="bill-approve-dialog"
           className="w-[min(520px,95vw)] rounded-3xl border border-primary/30 bg-background p-6 shadow-2xl">
        <h3 className="text-lg font-black text-primary">{t("acct.bills.approve.title")}</h3>
        <p className="mt-1 text-xs text-muted-foreground">
          {bill.supplier_invoice_no || "—"} · {bill.total} {bill.currency || ""}
        </p>
        <textarea data-testid="approve-note" value={note} onChange={(e) => setNote(e.target.value)}
                  placeholder={t("acct.bills.approve.notePh")}
                  className="mt-4 h-24 w-full resize-none rounded-2xl border-2 border-primary/30 bg-background p-3 text-sm" />
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <NeuButton data-testid="approve-cancel" onClick={onCancel}>{t("app.cancel")}</NeuButton>
          <NeuButton variant="danger" data-testid="approve-reject" disabled={busy} onClick={doReject}>
            <XCircle className="h-4 w-4" /> {t("acct.bills.approve.reject")}
          </NeuButton>
          <NeuButton variant="primary" data-testid="approve-confirm" disabled={busy} onClick={approve}>
            <CheckCheck className="h-4 w-4" /> {t("acct.bills.approve.confirm")}
          </NeuButton>
        </div>
      </div>
    </div>
  );
};
